/* SKY product page helpers:
   1. No pre-selected size (B2): Shopify pre-selects the first variant; on load
      every size radio is cleared and both buy paths are inert until the
      customer chooses. The add button reads "Choose your size" while inert.
   2. Buy it now - adds the chosen variant to the cart, goes to checkout.
   3. Size-guide row highlight - only after a size is chosen. */
(() => {
  if (window.skyPdpInit) return; window.skyPdpInit = true;

  const radios = () => [...document.querySelectorAll('.product-details fieldset.variant-option--buttons input[type="radio"]')];
  const atcBtn = () => document.querySelector('.product-details button[name="add"], .product-details .add-to-cart-button button');
  const buyBtn = () => document.querySelector('[data-sky-buynow]');
  const chosen = () => radios().some((r) => r.checked);

  const setState = () => {
    const ok = chosen();
    const atc = atcBtn(); const buy = buyBtn();
    if (atc) {
      atc.disabled = !ok;
      const label = atc.querySelector('.add-to-cart-text, span') || atc;
      if (!ok) { if (!atc.dataset.skyLabel) atc.dataset.skyLabel = label.textContent.trim(); label.textContent = 'Choose your size'; }
      else if (atc.dataset.skyLabel) { label.textContent = atc.dataset.skyLabel; }
    }
    if (buy) buy.disabled = !ok;
    highlight();
  };

  const highlight = () => {
    const sel = radios().find((r) => r.checked);
    const val = sel ? String(sel.value).trim() : '';
    document.querySelectorAll('.sky-sg tr[data-sky-eu]').forEach((tr) => {
      tr.classList.toggle('is-sel', val !== '' && tr.getAttribute('data-sky-eu') === val);
    });
  };

  const init = () => {
    // clear Shopify's default first-variant selection
    radios().forEach((r) => { r.checked = false; });
    setState();
    document.addEventListener('change', (e) => {
      if (e.target && e.target.matches('.product-details input[type="radio"]')) setState();
    });

    const buy = buyBtn();
    if (buy) {
      buy.addEventListener('click', async () => {
        if (!chosen()) return;
        const idEl = document.querySelector('.product-details form[action*="/cart/add"] [name="id"]');
        if (!idEl || !idEl.value) return;
        buy.disabled = true;
        try {
          const r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: Number(idEl.value), quantity: 1 }),
          });
          if (r.ok) { window.location.assign('/checkout'); return; }
        } catch (e) { /* fall through */ }
        buy.disabled = false;
      });
    }
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();

/* 4. Gallery bar (desktop): arrows + n/N + pips below the rail, driven by
   the theme slideshow's own prev/next controls and scroll position. */
(() => {
  const build = () => {
    const media = document.querySelector('.product-information__media');
    if (!media || media.querySelector('.sky-galbar')) return;
    const comp = media.querySelector('slideshow-component');
    const slides = [...media.querySelectorAll('slideshow-slide')];
    if (!comp || slides.length < 2) return;
    const prev = comp.querySelector('[ref="previous"]');
    const next = comp.querySelector('[ref="next"]');
    const bar = document.createElement('div');
    bar.className = 'sky-galbar';
    const mk = (cls, html) => { const e = document.createElement('button'); e.type = 'button'; e.className = cls; e.innerHTML = html; return e; };
    const a1 = mk('sky-galbar__arw', '&larr;'); a1.setAttribute('aria-label', 'Previous image');
    const a2 = mk('sky-galbar__arw', '&rarr;'); a2.setAttribute('aria-label', 'Next image');
    const count = document.createElement('span'); count.className = 'sky-galbar__count';
    const pips = document.createElement('span'); pips.className = 'sky-galbar__pips';
    slides.forEach(() => { const p = document.createElement('i'); p.className = 'sky-galbar__pip'; pips.appendChild(p); });
    bar.append(a1, a2, count, pips);
    comp.insertAdjacentElement('afterend', bar);
    const step = (dir) => {
      const before = scroller.scrollLeft;
      const btn = dir < 0 ? prev : next;
      if (btn) btn.click();
      setTimeout(() => {
        if (scroller.scrollLeft === before) {
          const w = slides[0].getBoundingClientRect().width + 6;
          scroller.scrollBy({ left: dir * w, behavior: 'smooth' });
        }
      }, 250);
    };
    const scroller = comp.querySelector('slideshow-slides') || comp.querySelector('[ref="scroller"]') || slides[0].parentElement;
    a1.addEventListener('click', () => step(-1));
    a2.addEventListener('click', () => step(1));
    const sync = () => {
      const w = slides[0].getBoundingClientRect().width || 1;
      const gap = parseFloat(getComputedStyle(scroller).columnGap || getComputedStyle(scroller).gap) || 0;
      const i = Math.min(slides.length - 1, Math.max(0, Math.round(scroller.scrollLeft / (w + gap))));
      count.textContent = (i + 1) + ' / ' + slides.length;
      [...pips.children].forEach((p, j) => p.classList.toggle('is-on', j === i));
    };
    scroller.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    sync();
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', build) : build();
})();

/* 5. Mobile order (Owner ruling): the colour strip sits directly under the
   gallery bar on <=750px - see the shoe, change the colour, then read the
   name and price. The block node is relocated (not duplicated); it moves
   back to the buy column when the viewport crosses 750px. */
(() => {
  const init = () => {
    const media = document.querySelector('.product-information__media');
    const sw = document.querySelector('.product-details .sky-pdp__swblock');
    if (!media || !sw) return;
    let wrap = sw;
    while (wrap.parentElement && !wrap.parentElement.classList.contains('group-block-content')) wrap = wrap.parentElement;
    const home = document.createComment('sky-swblock-home');
    wrap.before(home);
    const mq = matchMedia('(max-width: 749px)');
    const apply = () => {
      if (mq.matches) {
        const bar = media.querySelector('.sky-galbar');
        (bar || media.lastElementChild || media).after ? (bar ? bar.after(wrap) : media.appendChild(wrap)) : media.appendChild(wrap);
      } else if (home.parentNode) {
        home.parentNode.insertBefore(wrap, home.nextSibling);
      }
    };
    mq.addEventListener('change', apply);
    apply();
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
